import axios from 'axios'
import { FileObject } from './dropzone-area.types'

export function convertBytesToMbsOrKbs(filesize: number, locale: string) {
  let size = ''
  if (filesize >= 1000000) {
    size = `${filesize / 1000000} ${
      locale === 'ru' ? ' мегабайт' : ' megabytes'
    }`
  } else if (filesize >= 1024) {
    size = `${filesize / 1024} ${locale === 'ru' ? 'килобайт' : 'kilobytes'}`
  } else {
    size = `${filesize} ${locale === 'ru' ? 'байт' : 'bytes'}`
  }
  return size
}

export async function createFileFromUrl(url: string) {
  const response = await axios.get<Blob>(url, { responseType: 'blob' })
  const data = await response.data
  const metadata = { type: data.type }
  const filename = url.replace(/\?.+/, '').split('/').pop()
  return new File([data], filename ?? '', metadata)
}

export function readFile(file: File): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (event) => {
      if (event.target?.result) {
        resolve(event?.target?.result)
      }
    }
    reader.onerror = (event) => {
      reader.abort()
      reject(event)
    }
    reader.readAsDataURL(file)
  })
}

export const formatFileObject = (value: string | FileObject) => {
  if (typeof value === 'string') {
    return {
      data: value
    }
  }

  return value
}

export const getFileFromFileObjects = (fileObjs?: FileObject[]) =>
  (fileObjs ?? [])
    ?.filter(
      (
        file
      ): file is {
        file: File
        data: FileObject['data']
      } => {
        return 'file' in file
      }
    )
    .map((files) => files.file)
